import { matchIsValidTel } from "mui-tel-input";
import * as Yup from "yup";
const nipRegExp = /(^\d{8,}$|^$)/;

export const getFormSchema = (t) => {
	return Yup.object().shape({
		companyName: Yup.string().required(t("fill_required_fields")),
		nip: Yup.string()
			.required(t("fill_required_fields"))
			.matches(nipRegExp, t("invalid_nip_format")),
		firstName: Yup.string().required(t("fill_required_fields")),
		lastName: Yup.string().required(t("fill_required_fields")),
		email: Yup.string()
			.required(t("fill_required_fields"))
			.email(t("invalid_email_format")),
		phoneNumber: Yup.string()
			.required(t("fill_required_fields"))
			.test("phoneFormat", t("invalid_phone_format"), function (value) {
				return matchIsValidTel(value);
			}),
		password: Yup.string()
			.required(t("fill_required_fields"))
			.min(8, t("password_has_to_be_at_least_n_characters_long", { min: 8 })),
		passwordConfirm: Yup.string()
			.required(t("fill_required_fields"))
			.oneOf([Yup.ref("password")], t("passwords_has_to_match")),
		rulesAgreement: Yup.boolean().oneOf([true], "").required(""),
		dataProcessingAgreement: Yup.boolean().oneOf([true], "").required(""),
	});
};
